import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OroService } from '../oro.service';

import { FAQ } from '../domain/FAQ';
import { FAQResult } from '../domain/FAQResult';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  isDisabled = false;

  public faqs: Array<FAQ> = new Array<FAQ>();

  constructor(private router: Router, private oroService: OroService) { }

  ngOnInit(): void {

    console.log('faq.component');

    this.oroService.faqHub<FAQResult>('Hub').subscribe(
      (result: FAQResult) => {
        if (result.Success) {

          this.faqs = new Array<FAQ>();
          result.FAQs.forEach( x => {

            const lvItem = new FAQ();
            lvItem.Answer = x.Answer;
            lvItem.Order = x.Order;
            lvItem.Question = x.Question;

            this.faqs.push(lvItem);
          });

        } else {
          alert(result.Message);
        }
      }
    );
  }

  gotoHub() {

    this.isDisabled = true;
    this.router.navigateByUrl('/hub');
  }

}
